export function initializeMetaAPI(_, metas) {
    let meta = {};
    metas.add(() => meta);
    const setUser = (user) => {
        meta = Object.assign(Object.assign({}, meta), { user: user !== null && user !== void 0 ? user : undefined });
    };
    return {
        setUser,
    };
}
//# sourceMappingURL=initialize.js.map